function addOrRemoveFromArray<T>(array: T[] = [], item: T) {
  const exists = array.includes(item);
  return exists ? array.filter((c) => c !== item) : [...array, item];
}

export default addOrRemoveFromArray;
